import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 37 38"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#222120",
  "fill-rule": "evenodd",
  d: "M18.5.667C28.625.667 36.833 8.875 36.833 19S28.625 37.333 18.5 37.333.167 29.125.167 19 8.375.667 18.5.667zM21 17.333h-5V29h5zm-2.5-10a3.335 3.335 0 0 0 0 6.667 3.335 3.335 0 0 0 0-6.667z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render() { return h(NuxtIcon, {icon: {render}}) } }